import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabaseClient.ts';
import instaImg from '../img/images/instaa.png';
import { Link } from 'react-router-dom';
import { BiFontSize } from 'react-icons/bi';
// Main category list with icons

const linkStyle = {
  color: "#808080", // gray
  fontSize:"12px",
  textDecoration: "none",
  fontWeight: 200,
  transition: "color 0.3s",
};


function Footer() {
  const [footer, setFooter] = useState(null);
  const [socialLinks, setSocialLinks] = useState([]);
  const [policies, setPolicies] = useState([]);
  const [services, setServices] = useState([]);
  const [instaImages, setInstagram] = useState([]);
  const [shapes, setShapes] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
  const [{ data: policies }, { data: services }, { data: instagram }, { data: shapes }, { data: footer }, { data: social }] = await Promise.all([
  supabase.from('footer_policies').select('*'),
  supabase.from('footer_services').select('*'),
  supabase.from('footer_instagram').select('*'),
  supabase.from('footer_shapes').select('*'),
  supabase.from('footer').select('*').single(),
  supabase.from('footer_social_links').select('*'),
]);
setServices(services);

      setPolicies(policies);
      setServices(services);
      setInstagram(instagram);
      setShapes(shapes);
      setFooter(footer);
      setSocialLinks(social);

    };
    fetchData();
  }, []);


  if (!footer) return null;

  return (
    <footer>
      <div className="footer-top-area footer-bg">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-3">
              <div className="footer-widget">
                <div className="f-logo">
                  <img src={footer.logo_url} alt="" />
                </div>
                <div className="footer-text">
                  <p>{footer.description}</p>
                </div>
                <div className="footer-contact">
                  <div className="icon"><i className="fas fa-headphones" /></div>
                  <div className="content">
                    <h4 className="title"><a href={`tel:${footer.phone}`}>{footer.phone}</a></h4>
                    <span>Appelez-nous</span>
                  </div>
                </div>
            <div className="footer-social">
  <ul>
    {socialLinks.map(link => {
      // Ensure link has https://
      const finalUrl = link.url.startsWith("http")
        ? link.url
        : `https://${link.url}`;

      return (
        <li key={link.id}>
          <a 
            href={finalUrl} 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <i className={link.icon_class} />
          </a>
        </li>
      );
    })}
  </ul>
</div>

              </div>
            </div>
       <div className="col-2">
<div className="footer-widget">
  <h4 className="fw-title" style={{ marginBottom: "16px" }}>Nos Services</h4>
  <ul
    className="footer-navigation"
    style={{
      listStyle: "none",
      paddingLeft: 0,
      display: "flex",
      flexDirection: "column",
      gap: "10px",
      marginTop:"60px"
    }}
  >
    {services.map((service) => (
      <li key={service.id}>
        <Link to={service.url} style={linkStyle}>{service.title}</Link>
      </li>
    ))}
  </ul>
</div>


</div>

            <div className="col-2">
              <div className="footer-widget">
                <h4 className="fw-title">Nos Politiques</h4>
                <div className="fw-link">
                  <ul style={{ listStyle: "none", paddingLeft: 0, marginTop:"60px" }}>
                    {policies.map((item) => (
                      <li key={item.id}><a href={item.url} style={linkStyle}>{item.title}</a></li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-2">
              <div className="footer-widget">
                <h4 className="fw-title">Instagram</h4>
<a 
  href="https://www.instagram.com/animaliaplus/?hl=fr" 
  target="_blank" 
  rel="noopener noreferrer"
>
  <img 
    src={instaImg} 
    alt="Instagram"  
    className="footer-img" 
    style={{ 
      width: '270px', 
      height: '260px', 
      objectFit: 'contain', 
      cursor: 'pointer',
      marginLeft: window.innerWidth <= 768 ? '-60px' : '0px', // shift left on mobile
    }} 
  />
</a>

              </div>
            </div>

          </div>
        </div>
        {shapes.map(shape => (
          <div key={shape.id} className={`footer-shape ${shape.position === 'shape-two' ? 'shape-two' : ''}`}>
            <img src={shape.image_url} alt="" />
          </div>
        ))}
      </div>
      <div className="copyright-area">
        <div className="container">
          <p>{footer.copyright}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
